// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__2tE3a","image":"styles_image__2PBG2","paragraph":"styles_paragraph__1EaGr"};